import { render, staticRenderFns } from "./HowToCharacter.vue?vue&type=template&id=21f1695c&scoped=true&"
import script from "./HowToCharacter.vue?vue&type=script&lang=ts&"
export * from "./HowToCharacter.vue?vue&type=script&lang=ts&"
import style0 from "./HowToCharacter.vue?vue&type=style&index=0&id=21f1695c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f1695c",
  null
  
)

export default component.exports